import { C } from "@/lib/brand";

export function Spinner({ size = 28, color = C.peachDeep }) {
  return (
    <span
      data-testid="spinner"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        border: `3px solid ${color}33`,
        borderTopColor: color,
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite",
      }}
    >
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </span>
  );
}

export function FullPageLoader() {
  return (
    <div
      data-testid="full-page-loader"
      style={{
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner size={36} />
    </div>
  );
}
